module.exports = __webpack_public_path__ + "static/img/13.376620f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/13.png
// module id = GBZR
// module chunks = 0